import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-file-preview-modal',
  templateUrl: './file-preview-modal.component.html',
  styleUrls: ['./file-preview-modal.component.css'],
})
export class FilePreviewModalComponent implements OnInit {
  @Input() videoUrl: string | null = null;
  safeVideoUrl: SafeResourceUrl | null = null;
  isValidUrl: boolean = false;
  isMp4: boolean = false;

  constructor(private sanitizer: DomSanitizer, public modal: NgbActiveModal) {}

  ngOnInit(): void {
    this.validateAndSanitizeUrl();
  }

  private validateAndSanitizeUrl(): void {
    if (!this.videoUrl) return;

    // Check for YouTube embed
    if (this.videoUrl.includes('youtube.com/watch?v=')) {
      const videoId = this.videoUrl.split('v=')[1];
      const embedUrl = `https://www.youtube.com/embed/${videoId}`;
      this.safeVideoUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
      this.isValidUrl = true;
      this.isMp4 = false;
    }
    // Short YouTube URL
    else if (this.videoUrl.includes('youtu.be/')) {
      const videoId = this.videoUrl.split('youtu.be/')[1];
      const embedUrl = `https://www.youtube.com/embed/${videoId}`;
      this.safeVideoUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
      this.isValidUrl = true;
      this.isMp4 = false;
    }
    // MP4 video
    else if (this.videoUrl.endsWith('.mp4')|| this.videoUrl.endsWith('.mov') || this.videoUrl.endsWith('.mkv')) {
      this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.videoUrl
      );
      this.isValidUrl = true;
      this.isMp4 = true;
    } else {
      this.isValidUrl = false;
    }
  }
}
